import { render, staticRenderFns } from "./ArticlesIndicators.vue?vue&type=template&id=cf5c2480&"
import script from "./ArticlesIndicators.vue?vue&type=script&lang=js&"
export * from "./ArticlesIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports